window.Valence ||= {}
window.Valence.Utils ||= {}

window.Valence.Utils.File = {
  sanitizeFilename(originalFilename) {
    return originalFilename.replace(/ /g, '-').replace(/['"%]/g, '')
  },
}
